import Vue from 'vue';
import Vuex from 'vuex';
import api from '../services/api';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        config: null,
        categorias: [],
        partners: [],
        whatsappAgents: [],
        isLoading: true
    },
    
    mutations: {
        SET_CONFIG(state, config) {
            state.config = config;
        },
        SET_CATEGORIAS(state, categorias) {
            state.categorias = categorias;
        },
        SET_PARTNERS(state, partners) {
            state.partners = partners;
        },
        SET_WHATSAPP_AGENTS(state, agents) {
            state.whatsappAgents = agents;
        },
        SET_LOADING(state, isLoading) {
            state.isLoading = isLoading;
        }
    },
    
    actions: {
        async loadConfig({ commit }) {
            try {
                const response = await api.getConfiguration();
                commit('SET_CONFIG', response.data);
                console.log('Config loaded:', response.data);
            } catch (error) {
                console.error('Error loading config:', error);
            } finally {
                // IMPORTANTE: Siempre setear loading a false
                commit('SET_LOADING', false);
            }
        },
        
        async loadCategories({ commit }) {
            try {
                const response = await api.getCategories();
                commit('SET_CATEGORIAS', response.data);
            } catch (error) {
                console.error('Error loading categories:', error);
            }
        },
        
        async loadPartners({ commit }) {
            try {
                const response = await api.getPartners();
                commit('SET_PARTNERS', response.data);
            } catch (error) {
                console.error('Error loading partners:', error);
            }
        },
        
        async loadWhatsappAgents({ commit }) {
            try {
                const response = await api.getWhatsappAgents();
                commit('SET_WHATSAPP_AGENTS', response.data);
            } catch (error) {
                console.error('Error loading WhatsApp agents:', error);
            }
        },
        
        setLoading({ commit }, isLoading) {
            commit('SET_LOADING', isLoading);
        }
    },
    
    getters: {
        categorias: state => state.categorias,
        
        // CORREGIDO: Campos en inglés
        emails: state => {
            return state.config && state.config.emails ? state.config.emails : [];
        },
        
        phones: state => {
            return state.config && state.config.phones ? state.config.phones : [];
        },
        
        socialNetworks: state => {
            return state.config && state.config.social_networks ? state.config.social_networks : [];
        },
        
        whatsappAgents: state => {
            return state.whatsappAgents || [];
        }
    }
});